const locale = {
  'productList.filter.title': 'Filter',
  'productList.filter.reset': 'Reset',
  'productList.filter.manufacturer': 'Manufacturer',
  'productList.filter.manufacturer.placeholder': 'select manufacturer',
  'productList.filter.years': 'Years',
  'productList.filter.years.start.placeholder': 'start year',
  'productList.filter.years.end.placeholder': 'end year',
  'productList.filter.models': 'Car Model',
  'productList.filter.models.placeholder': 'select model',
  'productList.filter.bodycode': 'Body',
  'productList.filter.bodycode.placeholder': 'select body',
  'productList.filter.enginecode': 'Engine',
  'productList.filter.enginecode.placeholder': 'select engine',
  'productList.filter.catalogs': 'Catalogs',
  'productList.filter.catalogs.placeholder': 'select catalogs',

  'productList.message.addToListSuccessfully': 'Added to list successfully.',
  'productList.message.removingListSuccessfully': 'Removed from list successfully.',
  'productList.message.addToListFailed': 'Failed to add to list.',
  'productList.message.removingListFailed': 'Failed to remove from list.',

  'productList.loginGuidance.oeAndPrice':
    'You can view the remaining {total} OE items and prices after login.',
  'productList.loginGuidance.price': 'You can view prices after login.',

  'productList.old': 'old',
  'productList.old.tips':
    'This number is an old number and is no longer used by the automobile manufacturer currently.',
  'productList.replaceNum': 'Replacement number',
  'productList.replaceNum.OE': 'OE number',
  'productList.replaceNum.circulationRating': 'Circulation rating',
  'productList.replaceNum.price.OEM': 'OEM Price',
  'productList.replaceNum.price.aftermarket': 'Aftermarket Price',
  'productList.replaceNum.suspensionDate': 'Suspension date',
  'productList.replaceNum.suspensionDate.tips':
    'The date when the automobile manufacturer stopped using this number. If the date is empty, it indicates that the manufacturer is still using this number.',
};

export default locale;
